/* eslint-disable */
/**
 * 自 RBP2 平迁的 Canvas 合成逻辑；整文件关闭 ESLint，避免在保留行为的前提下大规模改写。
 * 浏览器侧仅使用 SVG 输出；`fs` 由 webpack `resolve.fallback` 排除。
 */
import QRCode from 'qrcode-svg';
import { qopTheme } from '../static/qop-code-templates/types';
import LSM from '../modules/cache/tool-local-storage';
import { LOCAL_STORAGE_KEYS } from '../modules/cache/local-storage.constant';
import i18n from '../i18n';

/** QOP 画布 Wi-Fi 块，与 RBP2 `project-setting-qop` 传入 `drawCanvas` 的结构一致 */
export type QopCanvasWifi = {
    type: 'wifi';
    name: string;
    password: string;
    security: string;
};

/** QOP 画布单桌 web 块（可含公网双码） */
export type QopCanvasWeb = {
    type: 'web';
    url: string;
    tableId: number | string;
    tableName: string;
    publicUrl?: string;
    publicTableId?: string | number;
};

const BASE_WIDTH = 1240;
const BASE_HEIGHT = 1748;

/**
 * WiFi QR 字符串中 `T:` 字段与 RBP2 一致；若传入历史值 WPA/WPA2 则映射为 WPA。
 * @param security - 当前加密方式文案
 */
const wifiQrSecurityType = (security: string): string => (security === 'WPA/WPA2' ? 'WPA' : security);

/**
 * 合成图片
 * @param sources 图片列表
 * @param options 配置
 */
export const mergeImages = function (sources: any[], options?: any) {
    let defaultOptions = {
        format: 'image/png',
        quality: 0.3125,
        width: undefined,
        height: undefined,
        Canvas: undefined,
        crossOrigin: undefined
    };


    if (sources === void 0) sources = [];
    if (options === void 0) options = {};

    return new Promise(function (resolve) {
        options = Object.assign({}, defaultOptions, options);

        // Setup browser/Node.js specific variables
        var canvas: any = window.document.createElement('canvas');
        var Image = options.Image || window.Image;

        // Load sources
        var images = sources.map(function (source: any) {
            return new Promise(function (resolve, reject) {
                // Convert sources to objectsF
                if (source.constructor.name !== 'Object') {
                    source = { src: source };
                }

                // Resolve source and img when loaded
                var img = new Image();
                img.crossOrigin = options.crossOrigin;
                img.onerror = function () { return reject(new Error('Couldn\'t load image')); };
                img.onload = function () { return resolve(Object.assign({}, source, { img: img })); };
                img.src = source.src;
            });
        });

        // Get canvas context
        var ctx = canvas.getContext('2d');

        // When sources have loaded
        resolve(Promise.all(images)
            .then(function (images: any) {
                // Set canvas dimensions
                // var getSize = function (dim: any) { return options[dim] || Math.max.apply(Math, images.map(function (image: any) { return image.img[dim]; })); };
                canvas.width = 786;
                canvas.height = 1115;

                // Draw images to canvas
                images.forEach(function (image: any) {
                    ctx!.globalAlpha = image.opacity ? image.opacity : 1;
                    return ctx!.drawImage(image.img, image.x || 0, image.y || 0);
                });


                if (options.Canvas && options.format === 'image/jpeg') {
                    // Resolve data URI for node-canvas jpeg async
                    return new Promise(function (resolve, reject) {
                        canvas.toDataURL(options.format, {
                            quality: options.quality,
                            progressive: false
                        }, function (err: any, jpeg: any) {
                            if (err) {
                                reject(err);
                                return;
                            }
                            resolve(jpeg);
                        });
                    });
                }

                // Resolve all other data URIs sync
                return canvas.toDataURL(options.format, options.quality);
            }));
    });
};

/**
 * 获取svg
 */
const getWifiDataUri = (name: string, color: string) => {
    let svg: string = '';
    switch (name) {
        case 'wifi':
            svg = `
                <svg width="64" height="64" viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M32 56.0003C30.1333 56.0003 28.5556 55.3559 27.2667 54.067C25.9778 52.7781 25.3333 51.2003 25.3333 49.3337C25.3333 47.467 25.9778 45.8892 27.2667 44.6003C28.5556 43.3114 30.1333 42.667 32 42.667C33.8667 42.667 35.4444 43.3114 36.7333 44.6003C38.0222 45.8892 38.6667 47.467 38.6667 49.3337C38.6667 51.2003 38.0222 52.7781 36.7333 54.067C35.4444 55.3559 33.8667 56.0003 32 56.0003ZM16.9333 40.9337L11.3333 35.2003C13.9556 32.5781 17.0338 30.5008 20.568 28.9683C24.1022 27.4359 27.9129 26.6688 32 26.667C36.0871 26.6652 39.8987 27.443 43.4347 29.0003C46.9707 30.5577 50.048 32.6688 52.6667 35.3337L47.0667 40.9337C45.1111 38.9781 42.8444 37.4448 40.2667 36.3337C37.6889 35.2225 34.9333 34.667 32 34.667C29.0667 34.667 26.3111 35.2225 23.7333 36.3337C21.1556 37.4448 18.8889 38.9781 16.9333 40.9337ZM5.6 29.6003L0 24.0003C4.08889 19.8225 8.86667 16.5559 14.3333 14.2003C19.8 11.8448 25.6889 10.667 32 10.667C38.3111 10.667 44.2 11.8448 49.6667 14.2003C55.1333 16.5559 59.9111 19.8225 64 24.0003L58.4 29.6003C54.9778 26.1781 51.0116 23.5008 46.5013 21.5683C41.9911 19.6359 37.1573 18.6688 32 18.667C26.8427 18.6652 22.0098 19.6323 17.5013 21.5683C12.9929 23.5043 9.02578 26.1817 5.6 29.6003Z" fill="${color}"/>
                </svg>           
            `
            break;
        case 'table':
            svg = `
                <svg width="64" height="64" viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M37.3332 26.4003V21.867C38.7998 21.2448 40.3003 20.7781 41.8345 20.467C43.3687 20.1559 44.9794 20.0003 46.6665 20.0003C47.8221 20.0003 48.9554 20.0892 50.0665 20.267C51.1776 20.4448 52.2665 20.667 53.3332 20.9337V25.2003C52.2665 24.8003 51.1883 24.5008 50.0985 24.3017C49.0087 24.1025 47.8647 24.0021 46.6665 24.0003C44.9776 24.0003 43.3554 24.2119 41.7998 24.635C40.2443 25.0581 38.7554 25.6465 37.3332 26.4003ZM37.3332 41.067V36.5337C38.7998 35.9114 40.3003 35.4448 41.8345 35.1337C43.3687 34.8225 44.9794 34.667 46.6665 34.667C47.8221 34.667 48.9554 34.7559 50.0665 34.9337C51.1776 35.1114 52.2665 35.3337 53.3332 35.6003V39.867C52.2665 39.467 51.1883 39.1665 50.0985 38.9657C49.0087 38.7648 47.8647 38.6652 46.6665 38.667C44.9776 38.667 43.3554 38.867 41.7998 39.267C40.2443 39.667 38.7554 40.267 37.3332 41.067ZM37.3332 33.7337V29.2003C38.7998 28.5781 40.3003 28.1114 41.8345 27.8003C43.3687 27.4892 44.9794 27.3337 46.6665 27.3337C47.8221 27.3337 48.9554 27.4226 50.0665 27.6003C51.1776 27.7781 52.2665 28.0003 53.3332 28.267V32.5337C52.2665 32.1337 51.1883 31.8332 50.0985 31.6323C49.0087 31.4314 47.8647 31.3319 46.6665 31.3337C44.9776 31.3337 43.3554 31.5452 41.7998 31.9683C40.2443 32.3914 38.7554 32.9799 37.3332 33.7337ZM17.3332 42.667C19.4221 42.667 21.4558 42.9008 23.4345 43.3683C25.4132 43.8359 27.3794 44.5354 29.3332 45.467V19.2003C27.5109 18.1337 25.5776 17.3337 23.5332 16.8003C21.4887 16.267 19.4221 16.0003 17.3332 16.0003C15.7332 16.0003 14.1438 16.1559 12.5652 16.467C10.9865 16.7781 9.46473 17.2448 7.99984 17.867V44.267C9.55539 43.7337 11.1003 43.3337 12.6345 43.067C14.1687 42.8003 15.7349 42.667 17.3332 42.667ZM34.6665 45.467C36.6221 44.5337 38.5892 43.8341 40.5678 43.3683C42.5465 42.9025 44.5794 42.6688 46.6665 42.667C48.2665 42.667 49.8336 42.8003 51.3678 43.067C52.9021 43.3337 54.4461 43.7337 55.9998 44.267V17.867C54.5332 17.2448 53.0105 16.7781 51.4318 16.467C49.8532 16.1559 48.2647 16.0003 46.6665 16.0003C44.5776 16.0003 42.5109 16.267 40.4665 16.8003C38.4221 17.3337 36.4887 18.1337 34.6665 19.2003V45.467ZM31.9998 53.3337C29.8665 51.6448 27.5554 50.3337 25.0665 49.4003C22.5776 48.467 19.9998 48.0003 17.3332 48.0003C15.4665 48.0003 13.6336 48.2448 11.8345 48.7337C10.0354 49.2225 8.31273 49.9114 6.6665 50.8003C5.73317 51.2892 4.83362 51.267 3.96784 50.7337C3.10206 50.2003 2.66828 49.4225 2.6665 48.4003V16.267C2.6665 15.7781 2.78917 15.3114 3.0345 14.867C3.27984 14.4225 3.64606 14.0892 4.13317 13.867C6.17761 12.8003 8.31095 12.0003 10.5332 11.467C12.7554 10.9337 15.0221 10.667 17.3332 10.667C19.9109 10.667 22.4336 11.0003 24.9012 11.667C27.3687 12.3337 29.7349 13.3337 31.9998 14.667C34.2665 13.3337 36.6336 12.3337 39.1012 11.667C41.5687 11.0003 44.0905 10.667 46.6665 10.667C48.9776 10.667 51.2443 10.9337 53.4665 11.467C55.6887 12.0003 57.8221 12.8003 59.8665 13.867C60.3554 14.0892 60.7225 14.4225 60.9678 14.867C61.2132 15.3114 61.3349 15.7781 61.3332 16.267V48.4003C61.3332 49.4225 60.9003 50.2003 60.0345 50.7337C59.1687 51.267 58.2683 51.2892 57.3332 50.8003C55.6887 49.9114 53.9669 49.2225 52.1678 48.7337C50.3687 48.2448 48.535 48.0003 46.6665 48.0003C43.9998 48.0003 41.4221 48.467 38.9332 49.4003C36.4443 50.3337 34.1332 51.6448 31.9998 53.3337Z" fill="${color}"/>
                </svg>
            `
            break;
        case 'key':
            svg = `
                <svg t="1681379713395" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="101105" width="200" height="200"><path d="M298.666667 426.666667a85.333333 85.333333 0 1 0 0 170.666666 85.333333 85.333333 0 0 0 0-170.666666z" fill="${color}" p-id="101106"></path><path d="M298.666667 266.666667a245.333333 245.333333 0 1 0 215.466666 362.666666h136.533334V725.333333c0 17.664 14.336 32 32 32h149.333333a32 32 0 0 0 32-32v-96H938.666667a32 32 0 0 0 32-32v-128A74.666667 74.666667 0 0 0 896 394.666667h-381.866667a245.290667 245.290667 0 0 0-215.466666-128zM117.333333 512a181.333333 181.333333 0 0 1 347.605334-72.533333c5.077333 11.648 16.597333 19.2 29.312 19.2H896a10.666667 10.666667 0 0 1 10.666667 10.666666v96H832a32 32 0 0 0-32 32v96h-85.333333V597.333333a32 32 0 0 0-32-32h-188.416a32 32 0 0 0-29.312 19.2A181.376 181.376 0 0 1 117.333333 512z" fill="${color}" p-id="101107"></path></svg>
            `
            break;
        case 'arrow':
            svg = `
                <svg width="64" height="64" viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M35.3834 9.7834C36.1836 8.98352 37.2686 8.53418 38.4 8.53418C39.5313 8.53418 40.6164 8.98352 41.4165 9.7834L60.6165 28.9834C61.4164 29.7835 61.8657 30.8686 61.8657 31.9999C61.8657 33.1313 61.4164 34.2164 60.6165 35.0165L41.4165 54.2165C40.6118 54.9937 39.534 55.4237 38.4153 55.414C37.2966 55.4043 36.2265 54.9556 35.4354 54.1645C34.6443 53.3734 34.1956 52.3033 34.1859 51.1846C34.1762 50.0659 34.6062 48.9881 35.3834 48.1834L46.9333 36.2666H6.39997C5.26838 36.2666 4.18313 35.8171 3.38298 35.0169C2.58282 34.2168 2.1333 33.1315 2.1333 31.9999C2.1333 30.8683 2.58282 29.7831 3.38298 28.9829C4.18313 28.1828 5.26838 27.7333 6.39997 27.7333H46.9333L35.3834 15.8165C34.5836 15.0164 34.1342 13.9313 34.1342 12.7999C34.1342 11.6686 34.5836 10.5835 35.3834 9.7834Z" fill="${color}"/>
                </svg>
            `
            break;
        case 'table2':
            svg = `
                <svg width="96" height="96" viewBox="0 0 96 96" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M56 39.6V32.8C58.2 31.8667 60.4507 31.1667 62.752 30.7C65.0533 30.2333 67.4693 30 70 30C71.7333 30 73.4333 30.1333 75.1 30.4C76.7667 30.6667 78.4 31 80 31.4V37.8C78.4 37.2 76.7827 36.7507 75.148 36.452C73.5133 36.1533 71.7973 36.0027 70 36C67.4667 36 65.0333 36.3173 62.7 36.952C60.3667 37.5867 58.1333 38.4693 56 39.6ZM56 61.6V54.8C58.2 53.8667 60.4507 53.1667 62.752 52.7C65.0533 52.2333 67.4693 52 70 52C71.7333 52 73.4333 52.1333 75.1 52.4C76.7667 52.6667 78.4 53 80 53.4V59.8C78.4 59.2 76.7827 58.7493 75.148 58.448C73.5133 58.1467 71.7973 57.9973 70 58C67.4667 58 65.0333 58.3 62.7 58.9C60.3667 59.5 58.1333 60.4 56 61.6ZM56 50.6V43.8C58.2 42.8667 60.4507 42.1667 62.752 41.7C65.0533 41.2333 67.4693 41 70 41C71.7333 41 73.4333 41.1333 75.1 41.4C76.7667 41.6667 78.4 42 80 42.4V48.8C78.4 48.2 76.7827 47.7493 75.148 47.448C73.5133 47.1467 71.7973 46.9973 70 47C67.4667 47 65.0333 47.3173 62.7 47.952C60.3667 48.5867 58.1333 49.4693 56 50.6ZM26 64C29.1333 64 32.184 64.3507 35.152 65.052C38.12 65.7533 41.0693 66.8027 44 68.2V28.8C41.2667 27.2 38.3667 26 35.3 25.2C32.2333 24.4 29.1333 24 26 24C23.6 24 21.216 24.2333 18.848 24.7C16.48 25.1667 14.1973 25.8667 12 26.8V66.4C14.3333 65.6 16.6507 65 18.952 64.6C21.2533 64.2 23.6027 64 26 64ZM52 68.2C54.9333 66.8 57.884 65.7507 60.852 65.052C63.82 64.3533 66.8693 64.0027 70 64C72.4 64 74.7507 64.2 77.052 64.6C79.3533 65 81.6693 65.6 84 66.4V26.8C81.8 25.8667 79.516 25.1667 77.148 24.7C74.78 24.2333 72.3973 24 70 24C66.8667 24 63.7667 24.4 60.7 25.2C57.6333 26 54.7333 27.2 52 28.8V68.2ZM48 80C44.8 77.4667 41.3333 75.5 37.6 74.1C33.8667 72.7 30 72 26 72C23.2 72 20.4507 72.3667 17.752 73.1C15.0533 73.8333 12.4693 74.8667 10 76.2C8.6 76.9333 7.25067 76.9 5.952 76.1C4.65333 75.3 4.00267 74.1333 4 72.6V24.4C4 23.6667 4.184 22.9667 4.552 22.3C4.92 21.6333 5.46933 21.1333 6.2 20.8C9.26667 19.2 12.4667 18 15.8 17.2C19.1333 16.4 22.5333 16 26 16C29.8667 16 33.6507 16.5 37.352 17.5C41.0533 18.5 44.6027 20 48 22C51.4 20 54.9507 18.5 58.652 17.5C62.3533 16.5 66.136 16 70 16C73.4667 16 76.8667 16.4 80.2 17.2C83.5333 18 86.7333 19.2 89.8 20.8C90.5333 21.1333 91.084 21.6333 91.452 22.3C91.82 22.9667 92.0027 23.6667 92 24.4V72.6C92 74.1333 91.3507 75.3 90.052 76.1C88.7533 76.9 87.4027 76.9333 86 76.2C83.5333 74.8667 80.9507 73.8333 78.252 73.1C75.5533 72.3667 72.8027 72 70 72C66 72 62.1333 72.7 58.4 74.1C54.6667 75.5 51.2 77.4667 48 80Z" fill="${color}"/>
                </svg>
            `
            break;
    }

    return 'data:image/svg+xml;charset=utf-8,' + encodeURIComponent(svg);
}


/**
 * 画圆角矩形
 * @param {*} ctx 
 * @param {*} x  圆角矩形起始坐标x
 * @param {*} y  圆角矩形起始坐标y
 * @param {*} width 矩形宽度
 * @param {*} height 矩形高度
 * @param {*} r 矩形圆角
 * @param {*} color 矩形边框颜色
 */
const drawRoundedRectangle = (ctx: CanvasRenderingContext2D, x: number, y: number, width: number, height: number, r: number, color: string, fillColor?: string) => {
    if (fillColor) ctx.fillStyle = fillColor;
    ctx.beginPath();
    ctx!.lineWidth = 4;
    ctx!.strokeStyle = color;
    ctx.moveTo(x + r, y);
    ctx.lineTo(x + width - r, y);
    ctx.arc(x + width - r, y + r, r, Math.PI * 1.5, Math.PI * 2);
    ctx.lineTo(x + width, y + height - r);
    ctx.arc(x + width - r, y + height - r, r, 0, Math.PI * 0.5);
    ctx.lineTo(x + r, y + height);
    ctx.arc(x + r, y + height - r, r, Math.PI * 0.5, Math.PI);
    ctx.lineTo(x, y + r);
    ctx.arc(x + r, y + r, r, Math.PI, Math.PI * 1.5);
    ctx.closePath();
    if (fillColor) ctx.fill();
    ctx!.stroke();
}

/**
 * 绘画红色的长矩形标志
 */
const drawRedTitle = (ctx: CanvasRenderingContext2D, param: RedRectangleType) => {
    const { x, y, width, height, r, type } = param;
    // 绘制红色圆角矩形
    ctx.fillStyle = '#ff5454';
    ctx.beginPath();
    ctx.moveTo(x + r, y);
    ctx.lineTo(x + width - r, y);
    ctx.quadraticCurveTo(x + width, y, x + width, y + r);
    ctx.lineTo(x + width, y + height - r);
    ctx.quadraticCurveTo(x + width, y + height, x + width - r, y + height);
    ctx.lineTo(x + r, y + height);
    ctx.quadraticCurveTo(x, y + height, x, y + height - r);
    ctx.lineTo(x, y + r);
    ctx.quadraticCurveTo(x, y, x + r, y);
    ctx.closePath();
    ctx.fill();

    // 绘制白色圆形背景
    ctx.fillStyle = 'white';
    const circleX = x + 64;
    const circleY = y + height / 2;
    ctx.beginPath();
    ctx.arc(circleX, circleY, 32, 0, Math.PI * 2);
    ctx.fill();

    // 绘制数字
    ctx.fillStyle = 'black';
    ctx.font = 'bold 42px Arial';
    ctx.textAlign = 'center';
    ctx.textBaseline = 'middle';

    const number = type === 'wifi' ? '1' : '2';
    ctx.fillText(number, circleX, circleY + 5);
    ctx!.stroke();
}

/**
 * 绘画文字与动态边框
 * x居中展示
 */
const drawTextWithBorder = (ctx: CanvasRenderingContext2D, text: string[], y: number, themesMap: qopTheme, fontSize: number = 38, showHeader: boolean = false, type: number = 1) => {
    const { tableColor, tipBorderColor, tipBorderFillColor } = themesMap;
    const borderColor = showHeader ? tipBorderColor === '#cccccc' ? '#cccccc' : '#9a9a9a' : tipBorderColor;
    const fontColor = showHeader ? '#030303' : tableColor;
    const fillColor = showHeader ? tipBorderFillColor === '#fff' ? '#fff' : 'rgba(255, 255, 255, 0.8)' : tipBorderFillColor;
    // 设置字体，以便测量文本宽度
    ctx!.font = `${fontSize}px Arial`;
    // 最大宽度
    let maxTextWidth = 0;

    // 添加标题
    const lineHeader: { [key: number]: string } = showHeader ? type === 3 ? {
        1: 'Wifi:',
        2: 'Password:',
    } : {
        0: 'Wifi:',
        1: 'Password:',
    } : {};
    // 计算每一行宽度，找出最大宽度
    text.forEach((line, index) => {
        let cloneLine = `${lineHeader[index] || ''}${line}`;
        const textWidth = ctx!.measureText(cloneLine).width;
        if (textWidth > maxTextWidth) {
            maxTextWidth = textWidth;
        }
    });

    // 定义文本的起始坐标
    const x = (BASE_WIDTH - maxTextWidth) / 2;

    const lineHieght = fontSize * 1.2;

    // 定义边框和背景的尺寸
    const paddingY = 16;
    const paddingX = 32;
    const borderWidth = 32;
    const rectX = x - paddingX;
    const rectY = y - (lineHieght) - paddingY + 5;
    const rectWidth = maxTextWidth + (2 * paddingX);
    const rectHeight = (lineHieght * text.length) + (2 * paddingY) ;

    // 绘制圆角边框
    drawRoundedRectangle(ctx!, rectX, rectY, rectWidth, rectHeight, borderWidth, borderColor, fillColor)

    text.forEach((line, index) => {
        const textY = y + (index * lineHieght);
        const header = lineHeader[index] || '';
        let cloneLine = `${header}${line}`;
        const lineTotalWidth = ctx!.measureText(cloneLine).width;
    
        // 计算开头位置
        const lineX = (BASE_WIDTH - lineTotalWidth) / 2;
        const headerWidth = ctx!.measureText(header).width;
        ctx!.textAlign = 'left';
    
        // 绘制header，颜色为红色
        ctx!.fillStyle = '#f35b5b';
        ctx!.fillText(header, lineX, textY); // header根据lineX居中
    
        // 绘制line，颜色为默认颜色
        ctx!.fillStyle = fontColor;
        ctx!.fillText(line, lineX + headerWidth, textY); // line在header后面绘制
    });

}

/**
 * 加载图片
 * @param sourceList 图片列表
 * @returns 
 */
const onloadImage = (sourceList: any[]) => {
    const images = sourceList.map(function (source: any) {
        return new Promise(function (resolve, reject) {
            var img = new Image(source.width, source.height);
            img.setAttribute('crossOrigin', 'anonymous');
            img.onerror = function (error) {
                console.log(source.x, 'onerror', error)
                return resolve(Object.assign({}, source, { img: img, error: true }));
            };
            img.onload = function () {
                return resolve(Object.assign({}, source, { img: img }));
            };
            img.src = source.src;

        });
    });
    return images
}

/**
 * 获取底图元素配置
 */
const getBaseImageSource = (templateUrl: string, themesMap: qopTheme, wifi: QopCanvasWifi, type: number) => {
    const rawServer = LSM.get(LOCAL_STORAGE_KEYS.SERVER_URL);
    const SERVER_URL = typeof rawServer === 'string' ? rawServer.replace(/\/+$/, '') : '';
    let sources: any[] = [];
    switch (type) {
        // 内网
        case 1:
            sources = [
                // 模板
                {
                    src: templateUrl,
                    x: 0,
                    y: 0,
                    width: BASE_WIDTH,
                    height: BASE_HEIGHT,
                },
                // 餐馆logo
                {
                    src: `${SERVER_URL}/qop/logo.jpg?randomId=${Math.random()}`,
                    x: 492,
                    y: 96,
                    width: 256,
                    height: 256,
                    borderRadius: 32,
                },
                // wifi图标
                {
                    src: getWifiDataUri('wifi', '#ffffff'),
                    x: 160 + 195,  
                    y: 1044 + 344 + 16,
                    width: 64,
                    height: 64,
                    rectangle: {
                        x: 160 + 32,      // 矩形左上角x坐标
                        y: 1044 + 344,     // 矩形左上角y坐标
                        width: 256,
                        height: 96,
                        r: 55,
                        type: 'wifi',
                    }
                },
                // 桌台图标
                {
                    src: getWifiDataUri('table', '#ffffff'),
                    x: 160 + 195 + 600,
                    y: 1044 + 344 + 16,
                    width: 64,
                    height: 64,
                    rectangle: {
                        x: 160 + 32 + 600,      // 矩形左上角x坐标
                        y: 1044 + 344,     // 矩形左上角y坐标
                        width: 256,
                        height: 96,
                        r: 55,
                        type: 'table',
                    }
                },
                // wifi二维码
                {
                    src: (() => {
                        const qrcodesvg = new QRCode({
                            content:
                                wifi.security === 'None'
                                    ? `WIFI:S:${wifi.name};T:nopass;P:;`
                                    : `WIFI:T:${wifiQrSecurityType(wifi.security)};S:${wifi.name};P:${wifi.password};`,
                            width: 320
                        }).svg().replace("<?xml version=\"1.0\" standalone=\"yes\"?>", '');
                        return 'data:image/svg+xml;charset=utf-8,' + encodeURIComponent(qrcodesvg);
                    })(),
                    x: 160,
                    y: 1044,
                    width: 320,
                    height: 320,
                    borderRadius: 32,
                },
                // 箭头
                {
                    src: getWifiDataUri('arrow', themesMap.tableColor),
                    x: 588,  
                    y: 1172,
                    width: 64,
                    height: 64,
                }
            ]
            break;
        
        // 外网
        case 2:
            sources = [
                // 模板
                {
                    src: templateUrl,
                    x: 0,
                    y: 0,
                    width: BASE_WIDTH,
                    height: BASE_HEIGHT,
                },
                // 餐馆logo
                {
                    src: `${SERVER_URL}/qop/logo.jpg?randomId=${Math.random()}`,
                    x: 492,
                    y: 96,
                    width: 256,
                    height: 256,
                    borderRadius: 32,
                },
                // 桌台图标
                {
                    src: getWifiDataUri('table2', '#ffffff'),
                    x: 428 + 128 + 64 - 48,
                    y: 1044 + 384 + 32 + 64 - 48,
                    width: 96,
                    height: 96,
                    circular: {
                        x: 428 + 128 + 64,      // 圆点x坐标
                        y: 1044 + 384 + 32 + 64,     // 圆点y坐标
                        r: 64,             // 圆半径
                    }
                },
            ]
            break;

        // 都有
        case 3:
            sources = [
                // 模板
                {
                    src: templateUrl,
                    x: 0,
                    y: 0,
                    width: BASE_WIDTH,
                    height: BASE_HEIGHT,
                },
                // wifi图标
                {
                    src: getWifiDataUri('wifi', '#ffffff'),
                    x: 192 + 179,  
                    y: 1076 + 312 + 16,
                    width: 64,
                    height: 64,
                    rectangle: {
                        x: 192 + 16,      // 矩形左上角x坐标
                        y: 1076 + 312,     // 矩形左上角y坐标
                        width: 256,
                        height: 96,
                        r: 55,
                        type: 'wifi',
                    }
                },
                // 桌台图标
                {
                    src: getWifiDataUri('table', '#ffffff'),
                    x: 192 + 179 + 568,
                    y: 1076 + 312 + 16,
                    width: 64,
                    height: 64,
                    rectangle: {
                        x: 192 + 16 + 568,      // 矩形左上角x坐标
                        y: 1076 + 312,     // 矩形左上角y坐标
                        width: 256,
                        height: 96,
                        r: 55,
                        type: 'table',
                    }
                },
                // wifi二维码
                {
                    src: (() => {
                        const qrcodesvg = new QRCode({
                            content:
                                wifi.security === 'None'
                                    ? `WIFI:S:${wifi.name};T:nopass;P:;`
                                    : `WIFI:T:${wifiQrSecurityType(wifi.security)};S:${wifi.name};P:${wifi.password};`,
                            width: 288
                        }).svg().replace("<?xml version=\"1.0\" standalone=\"yes\"?>", '');
                        return 'data:image/svg+xml;charset=utf-8,' + encodeURIComponent(qrcodesvg);
                    })(),
                    x: 192,
                    y: 1076,
                    width: 288,
                    height: 288,
                    borderRadius: 32,
                },
                // 箭头
                {
                    src: getWifiDataUri('arrow', themesMap.tableColor),
                    x: 588,  
                    y: 1204,
                    width: 64,
                    height: 64,
                }
            ]
            break;
    }
    return sources;
}

/**
 * 获取不同扫码方式的桌台二维码配置
 */
const getTableOptionsByType = (type: number) => {
    let options = {
        x: 0,
        y: 0,
        width: 0,
        height: 0,
    }
    switch (type) {
        // 内网
        case 1:
            options = {
                x: 160 + 600,
                y: 1044,
                width: 320,
                height: 320,
            }
            break;
        // 外网
        case 2:
            options = {
                x: 428,
                y: 1044,
                width: 384,
                height: 384,
            }
            break;
        // 全部
        case 3:
            options = {
                x: 192 + 568,
                y: 1076,
                width: 288,
                height: 288,
            }
            break;
    }
    return options;
}


/**
 * canvas画图
 */
export const drawCanvas = async (
    templateUrl: string,
    themesMap: qopTheme,
    wifi: QopCanvasWifi,
    web: QopCanvasWeb[],
    restaurantName: string,
    type: number,
    language: string,
)
    : Promise<{ name: string, data: string }[]> => {

    // 创建canvas
    const canvas = window.document.createElement('canvas');
    canvas.width = BASE_WIDTH;
    canvas.height = BASE_HEIGHT;

    var ctx = canvas.getContext('2d');

    const sources = getBaseImageSource(templateUrl, themesMap, wifi, type)

    // 加载底图
    var images = onloadImage(sources);

    // 生成底图
    await Promise.all(images)
        .then(function (images: any) {
            // var getSize = function (dim: any) { return options[dim] || Math.max.apply(Math, images.map(function (image: any) { return image.img[dim]; })); };
            canvas.width = BASE_WIDTH;
            canvas.height = BASE_HEIGHT;

            // Draw images to canvas
            images.forEach(function (image: any) {
                if (image?.error) return;
                ctx!.globalAlpha = image.opacity ? image.opacity : 1;
                // 红色矩形背景
                if (image.rectangle) {
                    ctx!.save();
                    drawRedTitle(ctx!, image.rectangle);
                    ctx!.clip();
                    ctx!.restore();
                    ctx!.drawImage(image.img, image.x || 0, image.y || 0, image.img.width, image.img.height);
                    return;
                }
                // 圆形背景
                if (image.circular) {
                    // icon的背景，圆形
                    ctx!.beginPath();
                    ctx!.arc(image.circular.x, image.circular.y, image.circular.r, 0, 360, false);
                    ctx!.fillStyle = "#ff5454";
                    ctx!.fill();
                }
                // 边框
                if (image.borderRadius) {
                    ctx!.save();
                    // 圆角矩形
                    drawRoundedRectangle(ctx!, image.x || 0, image.y || 0, image.img.width, image.img.height, image.borderRadius, '#000');
                    ctx!.clip();
                    ctx!.drawImage(image.img, image.x || 0, image.y || 0, image.img.width, image.img.height);
                    ctx!.restore();
                    return 
                }
                ctx!.drawImage(image.img, image.x || 0, image.y || 0, image.img.width, image.img.height);
            });
            // 餐馆名字
            ctx!.textAlign = 'center';
            ctx!.font = 'bold 64px Arial';
            ctx!.fillStyle = themesMap.tableColor;
            if (type !== 3) {
                ctx!.fillText(restaurantName, BASE_WIDTH / 2, 434);
            } else {
                /**
                 * "全部"的布局
                 */
                ctx!.fillText(restaurantName, BASE_WIDTH / 2, 150);
                // 'or'的圆形背景
                ctx!.beginPath();
                ctx!.arc(BASE_WIDTH / 2, 980, 48, 0, 360, false);
                ctx!.fillStyle = "#ff5454";
                ctx!.fill();
                // 'or'文字
                ctx!.fillStyle = '#fff';
                ctx!.fillText('or', BASE_WIDTH / 2, 1000);
            }
            // // 文字提示
            const getLanguage = i18n.getFixedT(language);
            const fontSize =  38;
            if (type === 3) {
                drawTextWithBorder(ctx!, [getLanguage('qop_setting_page_scan_by_network')], 790, themesMap, fontSize)
                drawTextWithBorder(ctx!, [getLanguage('qop_setting_page_scan_by_wifi'),
                    `${wifi.name || ''}`,
                    `${wifi.password || ''}`
                ], 1560, themesMap, fontSize, true, type)
            }
            if (type === 1) {
                drawTextWithBorder(ctx!, [
                    `${wifi.name || ''}`,
                    `${wifi.password || ''}`
                ], 1560, themesMap, fontSize, true, type)
            }
        })

    return new Promise(function (resolve) {

        const base = canvas.toDataURL('image/jpeg', 0.3);

        // 处理桌台
        const tableOption =  getTableOptionsByType(type)
        const websHandle = web.map(async (item, index) => {
            return new Promise(async function (resolve, reject) {
                const sources = [
                    // 底图
                    {
                        src: base,
                        x: 0,
                        y: 0,
                        width: BASE_WIDTH,
                        height: BASE_HEIGHT
                    },
                    // 桌台二维码
                    {
                        src: (() => {
                            const qrcodesvg = new QRCode({
                                content: item.url + `?table_id=${item.tableId}`,
                                width: tableOption.width
                            }).svg().replace("<?xml version=\"1.0\" standalone=\"yes\"?>", '');
                            return 'data:image/svg+xml;charset=utf-8,' + encodeURIComponent(qrcodesvg);
                        })(),
                        x: tableOption.x,
                        y: tableOption.y,
                        width: tableOption.width,
                        height: tableOption.height,
                        borderRadius: 32
                    }
                ]
                // 外网二维码
                if (type === 3 && item.publicUrl) {
                    sources.push({
                        src: (() => {
                            const qrcodesvg = new QRCode({
                                content: item.publicUrl + `?table_id=${item.publicTableId}`,
                                width: 320
                            }).svg().replace("<?xml version=\"1.0\" standalone=\"yes\"?>", '');
                            return 'data:image/svg+xml;charset=utf-8,' + encodeURIComponent(qrcodesvg);
                        })(),
                        x: 460,
                        y: 380,
                        width: 320,
                        height: 320,
                        borderRadius: 32
                    })
                }
                const images = onloadImage(sources);

                await Promise.all(images).then(function (images: any) {
                    // 绘画桌台二维码
                    images.forEach(function (image: any) {
                        if (image?.error) return;
                        ctx!.globalAlpha = image.opacity ? image.opacity : 1;
                        // 边框
                        if (image.borderRadius) {
                            ctx!.save();
                            // 圆角矩形
                            drawRoundedRectangle(ctx!, image.x || 0, image.y || 0, image.img.width, image.img.height, image.borderRadius, '#000');
                            ctx!.clip();
                            ctx!.drawImage(image.img, image.x || 0, image.y || 0, image.img.width, image.img.height);
                            return ctx!.restore();
                        }
                        return ctx!.drawImage(image.img, image.x || 0, image.y || 0, image.img.width, image.img.height);
                    });
                    const tableNameFontSize = item.tableName.length > 19 ? 80 : 128;
                    // 桌台名字
                    ctx!.textAlign = 'center';
                    ctx!.font = `bold ${tableNameFontSize}px Arial`;
                    ctx!.fillStyle = themesMap.tableColor;
                    ctx!.fillText(item.tableName, BASE_WIDTH / 2, type === 3 ? 300: 570);
                    // 生成base64
                    const base64 = canvas.toDataURL('image/jpeg', 0.3);
                    resolve({ name: item.tableName, data: base64 });
                }).catch((error) => {
                    console.log(item.tableName, 'error', error)
                    reject({ name: item.tableName, data: '' })
                })
            })
        })
        resolve(Promise.all(websHandle).then(result => {
            // 桌台重名，加数字防止被覆盖
            const nameList: string[]= [];
            result.forEach((item: any) => {
                const name = item?.name || '';
                if (nameList.includes(name)) {
                    let i = 1;
                    let newName = '';
                    while(true) {
                        if (!nameList.includes(`${name}(${i})`)) {
                            newName = `${name}(${i})`;
                            nameList.push(newName)
                            break;
                        }
                        i++
                    }
                    item.name = newName;
                } else {
                    nameList.push(item.name)
                }
            }) 
            return result as { name: string, data: string }[]
        }))

    })
}

// 红色矩形背景
type RedRectangleType = {
    x: number,  // 矩形左上角x坐标
    y: number,  // 矩形左上角y坐标
    r: number,  // 圆角半径
    width: number,  // 矩形宽度
    height: number,  // 矩形高度
    type: 'wifi' | 'table'
}
